import { colors } from "../../styles/Colors";
import { TimelineContainer, Bubble, TextBubblePrice, NextFeeText, BubbleSection, MiddleSection } from "./TimeLineStyledComponents";
import { TextBold, TextRegular } from "../../styles/GlobalStyledComponents";
import { formatDate } from "../../utils/dateTimeHelper";
import { pricesHelper } from "../../utils/paymentsHelper";
import IconCardBubble from "../../assets/icons/IconpaymentPlan/IconBubbleCard";
import IconPepperArrow from "../../assets/icons/IconPepperArrow";


interface TimelineProps {
    amountSimulated: number;
    dates: string[];
}

const Timeline: React.FC<TimelineProps> = ({ amountSimulated, dates }) => {

    return (
        <TimelineContainer id="timeline-container">
            <BubbleSection id="bubble-left-position">
                <TextBold id="text-bubble" fontSize={12} lineHeight={16} color="gray6">{formatDate(dates[0])}</TextBold>
                <Bubble id={`bubble-left`} backgroundColor={colors.red6}>
                    <IconCardBubble color={colors.white} />
                </Bubble>
                <TextBubblePrice red={true}>{amountSimulated && pricesHelper(amountSimulated)} €</TextBubblePrice>
            </BubbleSection>
            <MiddleSection id="bubble-middle-position">
                <NextFeeText id="text-above-line">Próxima cuota</NextFeeText>
                <IconPepperArrow />
            </MiddleSection>
            <BubbleSection id="bubble-right-position">
                <TextRegular id="text-bubble-price" fontSize={12} lineHeight={16}>{formatDate(dates[1])}</TextRegular>
                <Bubble id={`bubble-right`} backgroundColor={colors.white}>
                    <IconCardBubble color={colors.red6} />
                </Bubble>
                <TextBubblePrice>{amountSimulated && pricesHelper(amountSimulated)} €</TextBubblePrice>
            </BubbleSection>
        </TimelineContainer>
    );
};

export default Timeline;